
export default class IssueState {
  static DATE: IssueState
  static CHECK_DATE: IssueState
  static CLIENT: IssueState
  static CHECK_CLIENT: IssueState
  static CLIENT_CONTACT: IssueState
  static CHECK_CLIENT_CONTACT: IssueState
  static ITEMS: IssueState
  static CHECK_ITEMS: IssueState
  static CONFIRM: IssueState
  static BIZINFO: IssueState
  static pages: IssueState[]
  pageName: string = ''
  isConfirm: boolean = false
}

class IssueNormalState extends IssueState {
  isConfirm = false
  ok(handler) {
    const currentIndex = IssueState.pages.indexOf(handler.issueState)
    handler.issueState = IssueState.pages[currentIndex + 1]
    handler.transitionName = 'slide-right'
  }
  back(handler) {
    const currentIndex = IssueState.pages.indexOf(handler.issueState)
    handler.issueState = IssueState.pages[currentIndex - 1]
    handler.transitionName = 'slide-left'
  }
}

class IssueDateState extends IssueNormalState {
  pageName = 'date'
}

class IssueClientState extends IssueNormalState {
  pageName = 'client'
}

class IssueClientContactState extends IssueNormalState {
  pageName = 'client-contact'
}

class IssueItemsState extends IssueNormalState {
  pageName = 'items'
}

class IssueConfirmState extends IssueNormalState {
  pageName = 'confirm'

  checkDate(handler) {
    handler.issueState = IssueState.CHECK_DATE
    handler.transitionName = 'slide-right'
  }

  checkClient(handler) {
    handler.issueState = IssueState.CHECK_CLIENT
    handler.transitionName = 'slide-right'
  }

  checkClientContact(handler) {
    handler.issueState = IssueState.CHECK_CLIENT_CONTACT
    handler.transitionName = 'slide-right'
  }

  checkItems(handler) {
    handler.issueState = IssueState.CHECK_ITEMS
    handler.transitionName = 'slide-right'
  }

  checkBiz(handler) {
    handler.issueState = IssueState.BIZINFO
    handler.transitionName = 'slide-right'
  }
}

class IssueCheckState extends IssueState {
  isConfirm = true
  ok(handler) {
    handler.issueState = IssueState.CONFIRM
    handler.transitionName = 'slide-left'
  }

  back(handler) {
    handler.issueState = IssueState.CONFIRM
    handler.transitionName = 'slide-left'
  }
}

class IssueBizInfoState extends IssueCheckState {
  pageName = 'biz-info'
}

class IssueCheckDateState extends IssueCheckState {
  pageName = 'date'
}

class IssueCheckClientState extends IssueCheckState {
  pageName = 'client'
}

class IssueCheckClientContactState extends IssueCheckState {
  pageName = 'client-contact'
}

class IssueCheckItemsState extends IssueCheckState {
  pageName = 'items'
}

IssueState.DATE = new IssueDateState()
IssueState.CHECK_DATE = new IssueCheckDateState()
IssueState.CLIENT = new IssueClientState()
IssueState.CHECK_CLIENT = new IssueCheckClientState()
IssueState.CLIENT_CONTACT = new IssueClientContactState()
IssueState.CHECK_CLIENT_CONTACT = new IssueCheckClientContactState()
IssueState.ITEMS = new IssueItemsState()
IssueState.CHECK_ITEMS = new IssueCheckItemsState()
IssueState.CONFIRM = new IssueConfirmState()
IssueState.BIZINFO = new IssueBizInfoState()
IssueState.pages = [
  IssueState.DATE, IssueState.CLIENT, IssueState.CLIENT_CONTACT,
  IssueState.ITEMS, IssueState.CONFIRM, IssueState.BIZINFO
]
